/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-03-02 17:03:44
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-12-08 16:24:46
 * @FilePath: \sns-user-frontend\src\jsBridgeApi\oneplus.js
 * @Description: 
 */
import { setCookie } from '@/utils'

export default {
  // 隐藏电量栏
  hideTerminalBar (themeType, screenType) {
    window.HeytapJsApi.invoke({
			name: 'modifyStatusBar',
			module: "vip",
			data: {
				screenType,
        themeType
			}
		})
  },
  // 隐藏客户端头部
  hideClientTitle () {
		window.HeytapJsApi.invoke({
			name: 'hideToolbar',
			module: "vip",
			data: {
				toolbarType: 1
			}
		})
	},
  // 关闭客户端loading
	closeLoading () {
		window.HeytapJsApi.invoke({
			name: "onDomLoadFinish",
			module: "vip",
		})
	},
  // 开启新容器
	async openNewWebview (url, type) {
    // 1+app  openLink 方法可以识别帖子详情、圈子、话题链接打开具体app页面
    let data = {}
    try {
      const deviceInfo = await window.HeytapJsApi.invoke({
        name: 'getDeviceInfo',
        module: "common",
        data: {},
      })
      data = deviceInfo.data
    } catch {}
    if (Number(data?.versionCode) >= 41600) {
      window.HeytapJsApi.invoke({
        name: type === 'outterLink' ? 'open' : 'openLink',
        module: "common",
        data: {
          url,
          style: "vip",
        }
      })
    } else {
      // location.href = url
      window.open(url)
    }
	},
	// 获取登录态
	async getToken () {
		let res = await window.HeytapJsApi.invoke({
      name: "getToken",
      data: {},
      module: "vip",
    }) || {}
    if (res?.code === 0 && res?.data?.token) {
      setCookie("token", res.data.token);
    }
		return res
	},
  // 查看是否存在token
	async hasToken () {
    const data = await window.HeytapJsApi.invoke({
      name: 'hasToken',		// 方法名
      module: "common",
    })
    return data
	},
	// 返回上一级/销毁当前容器
	goBack (callback = null) {
    window.HeytapJsApi.invoke({
      name: 'goBack',
      module: "common",
      data: {},
    })
	},

	/**
	 * @param {
	 *      title: "分享标题", // 分享标题
	 *      description: "分享内容", // 分享详细描述
	 *      link: "testhttp://www.baidu.com", //链接
	 *      image:
	 *      "https://assorted.downloads.oppo.com/static/assets/products/encoM1/		images/1080/m1_3-947cf2d608f8b6b5fddbd07939fc7c18.jpg", // 分享图片
	 *      type: "link", // 分享资源的类型 可选link base64,base64时image需要传base64
	 * }
	 */
	share (data) {
    window.HeytapJsApi.invoke({
      name: "shareData",
      module: "common",
      data
    })
	},
  // 调起客户端给登录页面
	loginPage () {
    window.HeytapJsApi.invoke({
      name: "reqLogin",
      module: "common",
    })
	},
  async checkToken () {
		const res = await window.HeytapJsApi.invoke({
      name: 'hasToken',		// 方法名
      module: "common",
    })
    return res
	},
	// 获取设备信息
	async getDeviceInfo () {
		const data = await window.HeytapJsApi.invoke({
      name: 'getDeviceInfo',
      module: "common",
      data: {},
    })
    return data || {}
	},
	// 获取客户端消息
	async getClientContext () {
    const data = await window.HeytapJsApi.invoke({
      name: 'getDeviceInfo',
      module: "common",
      data: {},
    })
    return data || {}
	},
  // 获取版本信息
	async getSdkVersion () {
    const data = await window.HeytapJsApi.invoke({
      name: "common.sdk_version",
    })
    return data || {}
	},
	// 获取客户端消息
	async getAppInfo () {
    const data = await window.HeytapJsApi.invoke({
      name: "common.app_info",
    })
    return data || {}
	},
	async getNetworkState() {
    const data = await window.HeytapJsApi.invoke({
      name: "common.network_state",
    })
    return data || {}
	},
  logEvent(txt) {
    window.HeytapJsApi.invoke({
      name: "logEvent",
      module: "common",
      data : {
        'data': txt
      }
    })
  },
  // 保存海报图片
  transferData(data) {
		window.HeytapJsApi.invoke({
			name: 'transferData',
			module: "common",
			data
		})
	},

  // 拉起1+发布页
  openPostPage(data) {
    window.HeytapJsApi.invoke({
			name: 'handleThread',
      module: "common",
			data
		})
  },
  /**
   * @description 打开窗口/拉起app
   * @param {String} url 
   * @param {Number} flags  128：拉起app 
   * @returns 
   */
  openBrowser(url) {
    try {
      window.HeytapJsApi.invoke({
        name: 'openByBrowser',
        module: "common",
        data: {
          url: url || location.href,
        }
      })
    } catch {
      return false
    }
  },
  onResume(callback) {
		window.HeytapJsApi.registeAction("onResume", () => {
      typeof callback === "function" && callback();
    });
	},
  // state，0：停止左右滑动，1：恢复左右滑动
  handleHomeHorizontalScroll (state = 0) {
    try {
      window.HeytapJsApi.invoke({
        name: 'handleHomeHorizontalScroll',
        module: "common",
        data: {
          state
        }
      })
    } catch {}
  },
  // state，0：向下滚动，隐藏搜索框，1：向上滚动展示搜索框。
  handleHomeSearchDisplayState (state = 0) {
    try {
      window.HeytapJsApi.invoke({
        name: 'handleHomeSearchDisplayState',
        module: "common",
        data: {
          state
        }
      })
    } catch {}
  },
  // 更新装扮
  notifyDecorationUpdate () {
    try {
      window.HeytapJsApi.invoke({
        name: 'notifyDecorationUpdate',
        module: "common",
      })
    } catch {}
  }
}